import React from "react";
import Spinning from "grommet/components/icons/Spinning";
import Toast from "grommet/components/Toast";

const ImportLoading = ({ isLoading, error }) => {
  if (isLoading) {
    return <Spinning />;
  } else if (error) {
    return (
      <Toast status="critical">
        Sorry, there was a problem loading the page.
      </Toast>
    );
  } else {
    return null;
  }
};

export { ImportLoading };



// WEBPACK FOOTER //
// ./src/common/ImportLoading.js